module.exports = __webpack_public_path__ + "assets/e989ddef113ee1237f500ea560c1d673.png";